/**
 * Security configuration for the frontend
 * Define blocked domains and security settings here
 */

// List of blocked domains/patterns
const BLOCKED_DOMAINS = [
  /\.herokuapp\.com$/i,
  /\.heroku\.com$/i,
  // Add more blocked domains as needed
  // /\.example\.com$/i,
  // /\.malicious-site\.com$/i,
];

const config = {
  blockedDomains: BLOCKED_DOMAINS,
  // Enable/disable host blocking
  enabled: process.env.NODE_ENV === 'production' || process.env.VUE_APP_ENABLE_HOST_BLOCKING === 'true',
  // Custom error message
  errorMessage: 'Access to this application is not allowed from this domain.',
  // Log blocked attempts
  logBlockedAttempts: true,
};

export default config;
